module.exports = __webpack_public_path__ + "media/images/history/tacova2-d402eca9b440de41d5ac11bf2a556395.jpg";